var modProductRating = function(){
    var scope = ".js-mod-product-rating";
    ui.ready(
        scope,
        function($mod){
           var $ratingForm = $mod.find(scope+"__form");
           $ratingForm.submit(
                function(ev){
                    ev.preventDefault();
                    var $button = $ratingForm.find(scope+"__button");
                    var isOk = $ratingForm.checkRestrictions();
                    if(isOk){
                        $button.prop("disabled",true);
                        gvf.endpoint(
                            "web\\ratingController::sendProductRating",
                            [$ratingForm.getValues()],
                            function(response){
                                $button.prop("disabled",false);
                                utils.alertEndpointResponse(
                                    response,
                                    function(){
                                        if(response.status=="ok"){
                                            window.location = ("/zona-privada/mis-valoraciones");
                                        }
                                    }
                                );
                            }
                        );
                    }
                }
           );
        }
    );
}();

